import { ToolType, ToolTypeFilter } from 'lib-shared-types-api';

export const toolTypeLabel: Record<ToolType, string> = {
  'automation-task-tool': 'Action',
  'automation-handoff-tool': 'Handoff',
  'retrieval-tool': 'Knowledge',
  'procedure-tool': 'Procedure',
  'integration-tool': 'Platform Action',
};

export const toolTypeFilterLabel: Record<ToolTypeFilter, string> = {
  'automation-task': 'Action',
  'automation-handoff': 'Handoff',
  retrieval: 'Knowledge',
  procedure: 'Procedure',
  integration: 'Platform Action',
};
